<template>
  <div class="user-menu-wrapper" @mouseenter="handleWrapperMouseEnter" @mouseleave="handleWrapperMouseLeave">
    <div class="user-name" @click="goUserInfo">
      <div class="userImg" v-if="userDetail && userDetail.avatar">
        <img :src="baseUrl + userDetail.avatar">
      </div>
      <div class="user-nickname" :style="nicknameStyle"> {{ userDetail.nickName }} </div>
      <span class="dropdown-icon" :style="dropdownIconStyle"></span>
    </div>

    <!-- 用户悬浮菜单 -->
    <div class="user-menu" v-show="showMenu">
      <div class="user-menu-header" @click="goUserInfo" :style="{ backgroundImage: `url(${require(`@/assets/img/userPopup/${userDetail.starLevel || 0}.png`)})` }">
        <div class="user-avatar">
          <img :src="baseUrl + userDetail.avatar">
        </div>
        <div class="user-info">
          <div class="user-company">{{ userDetail.nickName }}</div>
          <div class="user-cert">
            <div class="authN" v-if="(userDetail.userType == '02' && userDetail.enterpriseStatus == '1')">
              <img src="@/assets/img/renzheng.png" alt="">
              已认证
            </div>
            <div class="levels" :style="levelStyle(userDetail.starLevel)">
              <img :src="require(`@/assets/img/userPopup/x${userDetail.starLevel || 0}.png`)" alt="">
              <span v-if="userDetail.starLevel == 0 || !userDetail.starLevel">普通用户</span>
              <span v-else-if="userDetail.starLevel == 1">一星用户</span>
              <span v-else-if="userDetail.starLevel == 2">二星用户</span>
              <span v-else-if="userDetail.starLevel == 3">三星用户</span>
              <span v-else-if="userDetail.starLevel == 4">四星用户</span>
              <span v-else-if="userDetail.starLevel == 5">五星用户</span>
            </div>
          </div>
        </div>

        <div class="hyc">
          <img
            :src="require(`@/assets/img/detail/c${userDetail.starLevel || 0}.png`)" alt="会员等级"
            style="width: 100%; height: 100%; object-fit: cover;">
        </div>
      </div>

      <div class="userNum" @click="goUserInfo">
        <div class="userNum-item">
          <div>{{ userDetail.remainingPoints }}</div>
          <div>剩余积分</div>
        </div>
        <div class="userNum-item">
          <div>{{ userDetail.publishTotalCount }}</div>
          <div>发布数</div>
        </div>
        <div class="userNum-item">
          <div>{{ userDetail.recommendTotalCount }}</div>
          <div>推荐数</div>
        </div>
        <div class="userNum-item">
          <div>{{ userDetail.visitTotalCount }}</div>
          <div>查看数</div>
        </div>
      </div>

      <div class="lineempty"></div>

      <div class="usermodel">
        <div class="oneheng">
          <div class="oneheng-item" @click="goToProfile(2)">
            <img src="@/assets/img/nav1.png" alt="">
            <div>发布记录</div>
          </div>

          <div class="oneheng-item" @click="goToProfile(3)">
            <img src="@/assets/img/nav2.png" alt="">
            <div>查看记录</div>
          </div>

          <div class="oneheng-item" @click="goToProfile(9)">
            <img src="@/assets/img/nav3.png" alt="">
            <div>投标记录</div>
          </div>
        </div>

        <div class="oneheng">
          <div class="oneheng-item" @click="goToProfile(4)">
            <img src="@/assets/img/nav4.png" alt="">
            <div>充值记录</div>
          </div>

          <div class="oneheng-item" @click="goToProfile(5)">
            <img src="@/assets/img/nav5.png" alt="">
            <div>消费记录</div>
          </div>

          <div class="oneheng-item" @click="goToProfile(8)">
            <img src="@/assets/img/nav6.png" alt="">
            <div>我的收藏</div>
          </div>
        </div>
      </div>


      <div class="lineempty" style="margin-bottom: 0;"></div>

      <div class="user-menu-footer" @click.stop="exitWebset">
        退出登录
      </div>
    </div>
  </div>
</template>

<script>
import { getSelfDetail } from '@/api/index'
import { removeToken } from '@/utils/auth';
import Cookies from "js-cookie";
import { getToken } from '@/utils/auth';
export default {
  name: 'UserMenu',
  props: {
    // 接收导航栏透明度状态，用于控制下拉三角颜色
    navOpacity: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showMenu: false,
      hideTimer: null,
      baseUrl: process.env.VUE_APP_BASE_API,
      userDetail: {}
    }
  },
  created() {
    if (!getToken()) {
      return
    }
    this.getUserDetail()
  },
  watch: {
    // 监听showMenu变化，当菜单显示时重新请求用户信息
    showMenu(newVal) {
      if (newVal) {
        this.getUserDetail();
      }
    }
  },
  computed: {
    // 根据导航栏透明度计算下拉三角颜色
    dropdownIconStyle() {
      // 当透明度为0时，三角为白色；当透明度为1时，三角为#0251AE
      // 可以根据需要调整颜色过渡效果
      return {
        borderTopColor: this.navOpacity === 0 ? '#FFFFFF' : '#0251AE'
      };
    },
    // 判断当前是否在首页
    isIndexPage() {
      return this.$route.path === '/index';
    },
    // 根据路由控制字体颜色
    nicknameStyle() {
      // 如果不是首页，字体颜色为黑色
      return {
        color: this.isIndexPage ? 'inherit' : '#000000'
      };
    }
  },
  methods: {
    getUserDetail() {
      getSelfDetail().then((response) => {
        this.userDetail = response.data
        this.$forceUpdate()
      })
    },
    // 获取等级样式
    levelStyle(level) {
      if (!level) return { backgroundColor: 'rgba(178, 83, 119,0.1)', color: '#B25377' };
      switch (level) {
        case 0:
          return { backgroundColor: 'rgba(178, 83, 119,0.1)', color: '#B25377' };
        case 1:
          return { backgroundColor: 'rgba(231, 119, 65,0.1)', color: '#E77741' };
        case 2:
          return { backgroundColor: 'rgba(131, 103, 119,0.1)', color: '#836777' };
        case 3:
          return { backgroundColor: 'rgba(208, 95, 212,0.1)', color: '#D05FD4' };
        case 4:
          return { backgroundColor: 'rgba(99, 103, 212,0.1)', color: '#6367D4' };
        case 5:
          return { backgroundColor: 'rgba(66, 116, 168,0.1)', color: '#4274A8 ' };
        default:
          return { backgroundColor: 'rgba(178, 83, 119,0.1)', color: '#B25377' };
      }
    },
    goUserInfo() {
      this.showMenu = false;
      this.$router.push('/profile');
    },
    goToProfile(id) {
      this.showMenu = false;
      this.$router.push({ name: 'profile', query: { id: id } });
    },
    exitWebset() {
      this.showMenu = false;
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken();
        Cookies.remove('nickName');
        this.isLogin = false;
        localStorage.removeItem('AccessToken_expriesTime')
        location.href = '/index';
      }).catch(() => {
      });
    },
    // 当鼠标进入整个包装器区域时
    handleWrapperMouseEnter() {
      // 清除可能存在的隐藏定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }

      // 立即显示菜单
      this.showMenu = true;
    },

    // 当鼠标离开整个包装器区域时
    handleWrapperMouseLeave() {
      // 清除可能存在的定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }

      // 设置延迟隐藏菜单
      this.hideTimer = setTimeout(() => {
        this.showMenu = false;
        this.hideTimer = null;
      }, 300); // 适当的延迟时间
    }
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }
  }
}
</script>

<style lang="scss" scoped>
.user-menu-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
  /* 确保整个区域能够正确捕获鼠标事件 */
}

/* 确保悬浮菜单和用户名称区域之间没有间隙，防止鼠标移动时触发mouseleave */
.user-menu {
  /* 移除margin-top，改为使用padding-top在包装器上，确保无缝过渡 */
  margin-top: 0;
}

.user-name {
  font-size: 14px;
  // 使用inline-block代替flex布局，避免影响文字超出隐藏
  display: inline-block;
  line-height: 35px;
  /* 与头像高度一致实现垂直居中 */
  cursor: pointer;
  max-width: 180px;
  display: flex;
  align-items: center;

  .userImg {
    height: 35px;
    width: 35px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
    vertical-align: middle;
    /* 垂直居中对齐 */

    img {
      width: 100%;
      height: 100%;
    }
  }

  .user-nickname {
    max-width: 90px;
    /* 设置最大宽度 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    white-space: nowrap;
    /* 防止文本换行 */
    margin-right: 2px;
  }

  .dropdown-icon {
    width: 0;
    height: 0;
    margin-left: 5px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 7px solid #666666;
    transition: transform 0.3s ease, border-top-color 0.3s ease;
  }

  &:hover {
    color: #FF6A00;

    .dropdown-icon {
      transform: rotate(180deg);
      border-top-color: #FF6A00;
    }
  }
}

// 用户悬浮菜单样式 - 整体缩小
.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  /* 使用padding-top代替margin-top，确保鼠标移动时不会触发mouseleave */
  box-sizing: border-box;
  width: 360px;
  /* 从320px缩小到280px */
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-menu-header {
  // background: linear-gradient(90deg, #FF6A00 0%, #FF8A00 100%);
  // padding: 16px;
  /* 从20px缩小到16px */
  height: 98px;
  // background-image: url('@/assets/img/userBack.png');
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding: 20px 20px 9px 20px;
  box-sizing: border-box;
  background-color: rgb(231, 119, 65, 0.13);
  position: relative;
}

.user-avatar {
  width: 58px;
  /* 从64px缩小到50px */
  height: 58px;
  border-radius: 50%;
  background: #fff;
  margin-right: 17px;
  /* 从16px缩小到12px */

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
}

.user-info {
  font-size: 14px;
  color: #333333;
  text-align: left;
  font-style: normal;
}

.user-company {
  font-size: 16px;
  /* 从18px缩小到16px */
  font-weight: 500;
  width: 180px;
  margin-bottom: 6px;
  /* 从8px缩小到6px */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-cert {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.user-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 16px;
  /* 从20px缩小到16px */
  background: #F9FAFB;
}

.stat-item {
  text-align: center;
  padding: 10px;
  /* 从12px缩小到10px */
  background: #fff;
  margin: 3px;
  /* 从4px缩小到3px */
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.stat-label {
  font-size: 12px;
  /* 从14px缩小到12px */
  color: #666;
  margin-bottom: 3px;
}

.stat-value {
  font-size: 16px;
  /* 从20px缩小到16px */
  font-weight: 600;
}

.publish-count {
  color: #FF6A00;
}

.visit-count {
  color: #1890FF;
}

.points-count {
  color: #52C41A;
}

.recommend-count {
  color: #9254DE;
}

.userNum {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;

  .userNum-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >div:nth-child(1) {
      font-weight: 900;
      font-size: 20px;
      color: #0251AE;
      text-align: center;
      font-style: normal;
    }

    >div:nth-child(2) {
      font-size: 14px;
      color: #333333;
      text-align: left;
      font-style: normal;
    }
  }
}

.lineempty {
  height: 1px;
  background-color: rgba(197, 197, 197, 0.1);
  width: 320px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.usermodel {
  .oneheng {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    .oneheng-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      text-align: center;
      font-style: normal;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        background-color: #F9FAFB;
        margin-bottom: 4px;
      }
    }
  }
}

.user-menu-footer {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-style: normal;
  height: 60px;
  width: 100%;
  cursor: pointer;
  line-height: 60px;
  // border-top: 1px solid #E5E7EB;
}

.authN {
  width: 73px;
  height: 22px;
  background: #6DD400;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  border-radius: 50px;
  // margin: 0 auto;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 22px;
  margin-right: 4px;

  img {
    width: 14px;
    height: 14px;
    margin-right: 2px;
  }
}

.authN2 {
  width: 83px;
  height: 22px;
  background: #FBE8DA;
  font-size: 12px;
  color: #E77741;
  text-align: center;
  border-radius: 50px;
  // margin: 0 auto;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 22px;
  margin-left: 10px;

  img {
    width: 14px;
    height: 12px;
    margin-right: 2px;
  }
}

.hyc {
  width: 93px;
  height: 70px;
  position: absolute;
  top: 19px;
  right: 3px;

  img {
    width: 100%;
    height: 100%;
  }
}

.noAuth {
  color: black !important;
  background: linear-gradient(90deg, #F3F4F6 0%, #E5E7EB 100%) !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;

  img {
    margin-right: 4px;
  }

  &:hover {
    background: #F5F5F5;
    color: #FF6A00;

    .menu-icon path {
      fill: #FF6A00;
    }
  }
}

.menu-icon {
  margin-right: 10px;
}


.levels {
  height: 22px;
  line-height: 22px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  border-radius: 12px;

  img {
    width: 14px;
    height: 13px;
    margin-right: 4px;
  }
}
</style>
